(function(){
  'use strict';
  if(window.lcMobileFiltersReady)return;
  window.lcMobileFiltersReady=true;
  document.documentElement.classList.add('lc-mobile-filters-ready');
  function toggleFor(group){return group?.querySelector('.lc-mobile-filter-toggle');}
  function close(group,restoreFocus){
    const toggle=toggleFor(group);
    if(!toggle)return;
    toggle.setAttribute('aria-expanded','false');
    if(restoreFocus&&toggle.isConnected)toggle.focus({preventScroll:true});
  }
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('.lc-mobile-filter-toggle');
    if(!toggle)return;
    toggle.setAttribute('aria-expanded',String(toggle.getAttribute('aria-expanded')!=='true'));
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape'||event.defaultPrevented)return;
    const group=event.target.closest('[data-lc-mobile-filters]');
    if(!group||toggleFor(group)?.getAttribute('aria-expanded')!=='true')return;
    event.preventDefault();close(group,true);
  });
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!form.matches('.lc-finder,#finder-form')||!form.checkValidity())return;
    const group=form.closest('[data-lc-mobile-filters]');
    if(group)close(group,group.contains(document.activeElement));
  });
})();
